import { formatAmount, formatAmountByLocale, formatNumber } from '@alk/numbers';
import { formatDate, formatDatetime } from '@alk/dates';
export function dateCellFormatter({ value, colDef }) {
    var _a;
    let substitutionValues = (_a = colDef === null || colDef === void 0 ? void 0 : colDef.cellRendererParams) === null || _a === void 0 ? void 0 : _a.substitutionValues;
    substitutionValues = Boolean(substitutionValues) ? JSON.parse(substitutionValues) : [];
    const substitutionValue = substitutionValues.find(substitutionValue => substitutionValue.from === value);
    if (Boolean(substitutionValue)) {
        return substitutionValue.to;
    }
    return formatDate(new Date(value));
}
export function datetimeCellFormatter({ value }) {
    return formatDatetime(new Date(value));
}
export function tenorCellFormatter({ value }) {
    const data = Boolean(value.toString) ? value.toString() : value;
    return data.split(':')[1];
}
export function amountCellFormatter({ value }) {
    return formatAmount(value);
}
export function rateCellFormatter({ value }) {
    return formatAmountByLocale(navigator.language)(4)(4)(value);
}
export function numberCellFormatter({ value }) {
    return formatNumber(value);
}
export function numberWithPrecisionCellFormatter(params) {
    const precisionDigits = params.colDef.cellRendererParams.precisionDigits;
    return formatAmountByLocale(navigator.language)(precisionDigits)(precisionDigits)(params.value);
}
export function percentageWithPrecisionCellFormatter(params) {
    const precisionDigits = params.colDef.cellRendererParams.precisionDigits;
    const value = formatAmountByLocale(navigator.language)(precisionDigits)(precisionDigits)(params.value);
    return `${value}%`;
}
export function basisPointWithPrecisionCellFormatter(params) {
    const precisionDigits = params.colDef.cellRendererParams.precisionDigits;
    const value = formatAmountByLocale(navigator.language)(precisionDigits)(precisionDigits)(params.value);
    return `${value} bp`;
}
export const noValueSkipperFormatter = (formatter) => (params) => typeof params.value !== 'undefined' && params.value !== null ? formatter(params) : undefined;
